export const BookingList = [
	{
		icon: "fas fa-bicycle",
		title: "Cycle Tours",
	},
	{
		icon: "fas fa-utensils",
		title: "Cooking Class"
	},
	{
		icon: "fas fa-cheese",
		title: "Food Tours"
	},
	{
		icon: "fas fa-shopping-cart",
		title: "Shopping Tours"
	},
	{
		icon: "fas fa-child",
		title: "Yoga and Vipasana classes"
	},
	{
		icon: "fas fa-moon",
		title: "Astrology Solution"
	},
	{
		icon: "fas fa-hot-tub",
		title: "Ayurvedic and Spa Massage"
	},
	{
		icon: "fas fa-play",
		title: "Dance and Music Class"
	},
	{
		icon: "fas fa-hotel",
		title: "Hotel and Taxi Services"
	},
];

